/*************************************************************************/
/****************** MOTEUR DE RECHERCHE SENSATION POPIN ******************/
/*************************************************************************/

	$(document).bind('_js_ready', function(evt) {

		/*** GESTION DE LA NAVIGATION AU CLAVIER ***/

			// Gestion tabindex suggestions
			let suggestions = $('#suggestions ul li a');

			function remove_tabindex() { suggestions.removeAttr('tabindex'); }
			function add_tabindex() { suggestions.attr('tabindex', '-1'); }

			// Piege au focus dans le sensation popin
			let focused_elt = function(elem) {

				// @INT : liste des éléments tabulables a adapter selon stucture html. Attention à l'ordre des éléments.
				let tabbable = elem.find('.search_area_cont.is_search #main_search, .search_area_cont.is_search input, .search_area_cont button, .search_area_cont .ui-menu-item a, .search_area_cont #show_more_results a, .search_area_cont #close_recherche').filter(':visible');

				let firstTabbable = tabbable.first();
				let lastTabbable = tabbable.last();

				/* Tabulation sur le dernier element renvoie au premier */
				lastTabbable.on('keydown', function (e) {
				   if ((e.which === 9 && !e.shiftKey)) {
					   e.preventDefault();
					   firstTabbable.focus();
				   }
				});

				/* Tabulation inverse sur le premier element renvoie au dernier */
				firstTabbable.on('keydown', function (e) {
					if ((e.which === 9 && e.shiftKey)) {
						e.preventDefault();
						lastTabbable.focus();
					}
				});
			};

		/*** GESTION DE LA SENSATION POPIN / ASPIRATION / ANIMATION ***/
			// Ajout des infos sensation full screen // Zone moteur dans bandeau image
			let isKeyUp = false;

			// Moteur recherche bandeau home
			let bandeau_reset = function () {
				$("#home .search_area_cont .close-button").on("click",function() {
					$("#home .search_area_cont").removeClass("is_search");
					$("#home .bandeau_page").removeClass("open_search");
					$("#home .search_area_cont #main_search").val('');
					$('body').removeClass('overflow is-reveal-open');
					$('main').css('z-index','1');
					isKeyUp = false;
					$("#show_more_results").addClass('hide');
					add_tabindex();
				});
			};

			let	bandeau_keyup = function() {
				$("#home .bandeau_page .search_area_cont #main_search").keyup(function(evt) {
					let alreadyFocus = false;
					if(evt.keyCode != 9 && evt.keyCode != 16){ // BUGFIX do not open sensation popin=when using tabulation
						if (isKeyUp != true) {
							$("#home .search_area_cont").addClass("is_search");
							$("#home .bandeau_page").addClass("open_search");
							$('body').addClass('overflow is-reveal-open');
							$('main').css('z-index','1006');
							$("#search_area_cont_append .titre_bloc").attr("aria-level", "2");
							$("#search_area_cont_append .titre_suggestions").attr("aria-level", "3");
							bandeau_reset();
							remove_tabindex();
							$(".search_area_cont.is_search #main_search").on("focusout",function() {
								if (alreadyFocus === false) {
									focused_elt($('#zone_moteur'));
									alreadyFocus = true;
								}
							});
							isKeyUp = true;
						}
					}
				});
			};
			bandeau_keyup();

			// Popin recherche
			let popin_reset = function () {
				$("#popin_recherche .wrap_popin .close-button").on("click",function() {
					$("#popin_recherche .wrap_popin").removeClass("is_search");
					$("#popin_recherche #main_search").val('');
					$('body').removeClass('is-reveal-open');
					isKeyUp = false;
					add_tabindex();
				});
			};

			let popin_keyup = function() {
				$("#popin_recherche #main_search").keyup(function() {
					if (isKeyUp != true) {
						$("#popin_recherche .wrap_popin").addClass("is_search");
						$('body').addClass('is-reveal-open');
						popin_reset();
						isKeyUp = true;
					}
				});
			};

			let placeholder_moteur = $('#home #zone_moteur #main_search').placeholderTypewriter({
				delay: 50,
				pause: 1500,
				text: [
					"Que recherchez-vous ?",
					"Un service ?",
					"Une information ?"
				]
			});
			placeholder_moteur.init();

		// Gestion aspiration du moteur / popin recherche
			let popin_home_search = $("#popin_recherche.home_search"),
				popin_page_search = $("#popin_recherche.page_search");

			// Gestion popin recherche sur la home
			popin_home_search.on("open.zf.reveal",function(){
				deleteAutocomplete();
				remove_tabindex();

				placeholder_moteur.destroy();
				let search_html = $("#search_area_cont_append").html();
				$("#zone_moteur #search_area_cont_append *").remove();
				$("#popin_recherche.home_search .wrap_popin .content > .cell").html(search_html);
				$("#popin_recherche.home_search .titre_bloc").attr("aria-level", "1");
				$("#popin_recherche.home_search .titre_suggestions").attr("aria-level", "2");
				bandeau_reset();
				popin_keyup();

				let placeholder_home_popin = $('#popin_recherche.home_search #main_search').placeholderTypewriter({
				  delay: 50,
				  pause: 1500,
				  text: [
				    "Je recherche ...",
				    "Un service ?",
				    "Une information ?"
				  ]
				});
				placeholder_home_popin.init();

				bindRecognition();
				bindAutocomplete();
			});

			popin_home_search.on("closed.zf.reveal",function(){
				deleteAutocomplete();
				add_tabindex();

				let popin_search_html = $("#popin_recherche.home_search .wrap_popin .content > .cell").html();
				$("#popin_recherche.home_search .wrap_popin .content > .cell *").remove();
				$("#zone_moteur #search_area_cont_append").html(popin_search_html);

				$("#popin_recherche.home_search .titre_bloc").attr("aria-level", "2");
				$("#popin_recherche.home_search .titre_suggestions").attr("aria-level", "3");

				popin_reset();
				bandeau_keyup();

				let placeholder_moteur_2 = $('#home #zone_moteur #main_search').placeholderTypewriter({
				  delay: 50,
				  pause: 1500,
				  text: [
					"Je recherche ...",
					"Un service ?",
					"Une information ?"
				  ]
				});
				placeholder_moteur_2.init();

				bindRecognition();
				bindAutocomplete();
			});

		// Gestion popin recherche sur les autres pages
			let placeholder_popin = $('#popin_recherche #main_search').placeholderTypewriter({
				delay: 50,
				pause: 1500,
				text: [
					"Que recherchez-vous ?",
					"Un service ?",
					"Une information ?"
				]
			});

		popin_page_search.on("open.zf.reveal",function(){
			placeholder_popin.init();
			remove_tabindex();
		});

		popin_page_search.on("closed.zf.reveal",function(){
			placeholder_popin.destroy();
			add_tabindex();
		});
	});


/*************************************************************************/
/************************ RECONNAISSANCE VOCALE **************************/
/*************************************************************************/

	let SpeechRecognition, recognition;
	let bindRecognition = function() {
		$("button.vocal").on('click',function(){
			recognition.abort()
			$(".search_area_cont #main_search").trigger('keyup');
			$("button.vocal").addClass("vocalRecognitionOn");
			recognition.start();
			recognition.onresult = function(event) {
				for (i = event.resultIndex; i < event.results.length; i++) {
					$("#main_search, #main_search_elastic").val(event.results[i][0].transcript);
					$("#main_search, #main_search_elastic").focus();
					$("#searchEngineForm").submit();
					$("#main_search").autocomplete('search');
				}
			}
			recognition.onspeechend = function() {
				recognition.stop();
				$("#main_search").autocomplete('search');
				$("button.vocal").removeClass("vocalRecognitionOn");
			}
			recognition.onerror = function(event) {
				if (event.error=="not-allowed")
				{
					alert("Vous n'avez pas autorisé l'utilisation du micro !");
				}
				console.log('Error occurred in recognition: ' + event.error);
				$("button.vocal").removeClass("vocalRecognitionOn");
			}
		});
	}

	$(document).bind('_js_ready', function() {
		try {
			//Try to define SpeechRecognition
			SpeechRecognition = (window.SpeechRecognition || window.webkitSpeechRecognition);
			recognition = new SpeechRecognition();
			recognition.lang = 'fr-FR';
			recognition.interimResults=true;
			bindRecognition();
		} catch (e) {
			// if no SpeechRecognition API delete mic icon from display
			$("button.vocal").remove();
			$("#bouton_recherche").addClass("noVocalRecognition");
		}
	});